import { fromRsData, getSettlement, postTaxPdf, toRsData } from "crud/auth.crud";
import React, { Fragment, useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import Modal from "components/RopikCustom/Modal";
import weaverOverlay from "../../assets/images/weaver_overlay.png"
import Loading from "pages/Custom/Loading";


const SettlementDetails = (props) => {
  const { companyName, companyNumber, settlementDate, getListLength, searchState, paymentStatus } = props;
  const [dataList, setDataList] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [detailData, setDetailData] = useState()
  const [onUpload, setOnUpload] = useState(false);
  const [pdfUrl, setPdfUrl] = useState();

  const getDataList = async () => {
    setOnUpload(true)
    const params = {
      type: 'wearing',
      company_name: companyName || '',
      company_number: companyNumber || '',
      settlement_date: settlementDate || '',
      state: paymentStatus
    }

    let url = '/payment_report/payment_report_list/?company_name=' + params.company_name + '&company_number=' + params.company_number + '&settlement_date=' + params.settlement_date + '&state=' + params.status + '&type=' + params.type;
    const response = await getSettlement(url);
    if (response.status === 200) {
      const content = response.data?.data || [];
      if (content.length > 0) {
        setDataList([...content])
        getListLength(content.length || 0)
      } else {
        setDataList([])
      }
    }
    setOnUpload(false)
  }

  const saveTaxBill = async (str) => {

    setOnUpload(true)

    const toDate = moment(new Date()).format('YYYYMMDDhhmmss');
    const mgtKey = toDate + '-' + detailData?.id;

    const fromRs = await fromRsData(detailData?.company_from.id);
    const fromData = fromRs.data || {}

    const toRs = await toRsData(detailData?.company_to.id);
    const toData = toRs.data || {}

    const params = {
      payment_report_id: detailData?.id,
      company_from_number: fromData.company_number,
      company_from_name: fromData.name,
      company_from_user_name: fromData.username,
      company_from_address: fromData.address1 + fromData.address2,
      company_from_email: fromData.email,
      company_from_phone: fromData.phone,
      company_from_mobile: fromData.mobile_phone,
      company_from_type: fromData.type,
      company_from_sector: fromData.type,
      company_to_number: toData.company_number,
      company_to_name: toData.name,
      company_to_user_name: toData.username,
      company_to_address: toData.address1 + toData.address2,
      company_to_email: toData.email,
      company_to_phone: toData.phone,
      company_to_mobile: toData.mobile_phone,
      company_to_fax: toData.fax,
      company_to_type: toData.type,
      company_to_sector: toData.type,
      price: parseInt(detailData?.payed_price * (10 / 11)),
      vat: detailData?.payed_price - parseInt(detailData?.payed_price * (10 / 11)),
      total_price: detailData?.total_payment_price,
      mgt_key: mgtKey,
      mgt_date: toDate,
      taxbill_type: str
    }

    const response = await registTaxBill(params)
    setOnUpload(false)
  }

  const clickList = async (item) => {
    const params = {
      id: item.id,
      settlement_date: settlementDate
    }
    const rs = await postTaxPdf(params);
    setDetailData(item);
    setModalShow(true)
    setPdfUrl(rs.data?.data || '')
  }

  const downloadPdf = () => {
    const url = pdfUrl;
    const win = window.open(url, '_blank');
    win.focus();
  };

  const modalClose = () => {
    setModalShow(false)
  }

  // const downloadPdf = () => {
  //   const url = pdfUrl;
  //   fetch(url)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       const pdf = window.URL.createObjectURL(new Blob([blob]));
  //       const link = document.createElement('a');
  //       link.href = pdf;
  //       link.setAttribute('download', '세금계산서.pdf');
  //       document.body.appendChild(link);
  //       link.click();
  //     })
  //     .catch((error) => {
  //       console.error('에러내용 >>> ', error)
  //     })
  // };

  useEffect(() => {
    getDataList()
  }, [settlementDate, searchState, paymentStatus])

  return (
    <Row>
      <Col xs="12">
        <div className="email-rightbar mb-3">
          <Card>
            <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
              <div className="table-responsive">
                <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">사업자번호</th>
                      <th scope="col">처리장명</th>
                      <th scope="col">인계량(kg)</th>
                      <th scope="col">고지금액(원)</th>
                      <th scope="col">고지일자</th>
                      <th scope="col">납부여부</th>
                      <th scope="col">고지상세</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody clickable">

                    {
                      dataList && dataList.map((item, index) => {
                        return (
                          <tr key={item.id + '_' + index}>
                            <td>{dataList.length - index}</td>
                            <td>{item.company_from.company_number}</td>
                            <td>{item.company_from.name}</td>
                            <td scope="row">{Util.setCommaPrice(item.qty_kg)}</td>
                            <td scope="row">{Util.setCommaPrice(item.total_price)}</td>
                            <td>{moment(item.report_date).format('YYYY-MM-DD')}</td>
                            <td scope="row">{item.state === 'Y' || item.total_price === 0 ? '완납' : item.state === 'N' && item.total_price > 0 ? '미납' : '부분납부'}</td>
                            <td>
                              <div className="btn-group waver-common-btn-group">
                                <button type="button" className="custom-btn border-radius-0 primary-bg white-text button-border margin-right-0" style={{ width: 114 }} onClick={(e) => {
                                  e.stopPropagation()
                                  clickList(item)
                                }}>
                                  고지상세
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                    }
                    {dataList.length === 0 &&
                      <tr>
                        <td scope="row" colSpan="6">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
      {onUpload && <Loading />}

      <Modal title={''} show={modalShow} onHide={modalClose} size="md"><div className="d-flex justify-content-center w-100">
        <div className="bill-mock-up">
          <div className="header">
            <p className="header-text">{moment(detailData?.summary_date).format('YYYY') + '년 ' + moment(detailData?.summary_date).format('MM') + '월 고지내역 상세'}</p>
          </div>
          <div className="main-banner">
            <div className="text-container">
              <p className="banner-main-text">스마트<br /><span>수거 플랫폼</span></p>
              <p className="banner-sub-text">Smart Food Waste Collection Platform</p>
            </div>
            <img className="logo" src={weaverOverlay} />
          </div>
          <p className="company">{detailData?.company_from?.name}</p>
          <Fragment>
            <div className="charge-box margin-top-14">
              <div className="d-flex align-items-end">
                <p className="charge">고지 내역</p>
              </div>
              <div className="charge-container">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="all-charge-text">총 금액</p>
                  <div className="white-value-box">
                    <p className="box-text all-charge-box-text">{Util.setCommaPrice(detailData?.total_payment_price)}</p>
                  </div>
                </div>
                <p className="explanation">정산금액은 인계된 폐기물의 양을 기준으로 합니다.</p>
              </div>
              <div className="charge-container">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="month-charge-text">납부금액</p>
                  <div className="white-value-box">
                    <p className="box-text">{Util.setCommaPrice(detailData?.payed_price)}</p>
                  </div>
                </div>
              </div>
              <div className="charge-container">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="unpaid-text">미납금액</p>
                  <div className="white-value-box">
                    <p className="box-text">{Util.setCommaPrice(detailData?.total_payment_price - detailData?.payed_price)}</p>
                  </div>
                </div>
              </div>
              <div className="charge-container">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="unpaid-text">완납여부</p>
                  <div className="white-value-box">
                    <p className="box-text">{detailData?.state === 'Y' || detailData?.total_price === 0 ? '완납' : detailData?.state === 'N' && detailData?.total_price > 0 ? '미납' : '부분납부'}</p>
                  </div>
                </div>
              </div>
              <div className="line line-1"></div>
              <div className="line line-2"></div>
            </div>
            <div className="charge-box margin-top-12">
              <div className="d-flex align-items-end">
                <p className="charge">미납금액</p>
              </div>
              <div className="charge-container">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="month-charge-text">당월 미정산액</p>
                  <div className="white-value-box">
                    <p className="box-text">{Util.setCommaPrice(detailData?.total_price - detailData?.payed_price)}</p>
                  </div>
                </div>
              </div>
              <div className="charge-container">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="unpaid-text">이전 미정산액</p>
                  <div className="white-value-box">
                    <p className="box-text">{Util.setCommaPrice(detailData?.prev_price)}</p>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
          {(detailData?.tax_state === 'Y' && detailData?.total_payment_price === detailData?.payed_price) || (detailData?.tax_state === 'D' && detailData?.total_payment_price !== detailData?.payed_price) &&
          <button className="payment-button" style={{ marginBottom: -48 }} onClick={() => {
            downloadPdf()
          }}>
            <p>세금계산서 다운로드</p>
          </button>
          }
          {detailData?.tax_state !== 'Y' && detailData?.total_payment_price === detailData?.payed_price &&
          <button className="payment-button" style={{ marginBottom: -48 }} onClick={() => {
            saveTaxBill('영수')
          }}>
            <p>세금계산서 영수증 작성</p>
          </button>
          }
          {detailData?.tax_state === 'N' && detailData?.total_payment_price !== detailData?.payed_price &&
          <button className="payment-button" style={{ marginBottom: -48 }} onClick={() => {
            saveTaxBill('청구')
          }}>
            <p>세금계산서 청구서 작성</p>
          </button>
          }
        </div>
      </div>
      </Modal>
    </Row>
  )
}

export default SettlementDetails
